import React from 'react'

import { trackEvent } from '../../app/ga'

export default function DownloadSection({
  title,
  description,
  demoLink,
  demoQrCode,
  demoImage,
}) {
  return (
    <section id="download" data-scroll-index="3" className="main-section">
      {/*<!-- Overlay Color -->*/}
      <div className="gradient-color overlay" />

      <div className="container">
        {/*<!--Title-->*/}
        <h4 className="reflection-text reflection-text-white p-b-2">{title}</h4>

        {/*<!-- Description -->*/}
        <p className="p-t-1 desc">{description}</p>

        <div className="row p-t-2">
          <div className="col s12 l9">
            {/*<!-- Link to download on the Apple store -->*/}
            <a
              href={demoLink}
              onClick={() => trackEvent('demo', 'click')}
              target="_blank"
              className="m-t-1 grey darken-4 waves-effect waves-light"
            >
              <span className="big-icon">
                <i className="fa fa-globe" />
              </span>

              <span className="text">Try it out</span>
            </a>

            <a
              className="waves-effect waves-light"
              href={demoQrCode}
              onClick={() => trackEvent('demo', 'qr')}
              data-lity
            >
              Scan QR Code
            </a>
          </div>

          {/*<!-- Iphone Image on right -->*/}
          <div
            className="col s12 l3 hide-on-med-and-down"
            data-aos="fade-left"
            data-aos-delay="100"
          >
            <img className="responsive-img" src={demoImage} alt="demo-image" />
          </div>
        </div>
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./src/components/Sections/DownloadSection.js